<!--Navbar-->
<mdb-navbar *ngIf="!isHideOnUrl() && loginServ.isUserLoggedIn() && user && user.initialSetup" SideClass="navbar navbar-expand-lg navbar-dark blue darken-1" [containerInside]="false">

    <!-- Navbar brand -->
    <mdb-navbar-brand>
        <a class="navbar-brand mr-5" href="/chatWithFriends">
            <img src="../../../assets/smiley_logo.png" height="70" alt="">
        </a>
    </mdb-navbar-brand>

    <!-- Collapsible content -->
    <links>
        <ul class="navbar-nav ml-auto">
        </ul>
        <!-- Links -->
        <ul class="navbar-nav ml-auto">
            <li class="nav-item">
                <a routerLink="/chat" class="nav-link waves-light" mdbWavesEffect>
                    <mdb-icon fas icon="comment"></mdb-icon>
                </a>
            </li>
        </ul>

        <ul class="navbar-nav ml-auto">
        </ul>

        <ul class="navbar-nav ml-auto">
            <li class="nav-item">
                <a routerLink="/profile" class="nav-link waves-light" mdbWavesEffect>
                    <mdb-icon fas icon="user"></mdb-icon>
                </a>
            </li>
        </ul>

        <ul class="navbar-nav ml-auto">
        </ul>

        <!-- Links -->

        <ul class="navbar-nav ml-auto nav-flex-icons">
            <li class="nav-item">
                <a routerLink="/logout" class="nav-link waves-light" mdbWavesEffect>
                    {{user.email}}
                    <mdb-icon fas icon="power-off"></mdb-icon>
                </a>
            </li>
        </ul>


    </links>
    <!-- Collapsible content -->

</mdb-navbar>
<!--/.Navbar-->